// import { bootstrapApplication } from '@angular/platform-browser';
// import { appConfig } from './app/app.config';
// import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { resetStaleAuthStorage } from './app/auth-bootstrap';

resetStaleAuthStorage();

// bootstrapApplication(AppComponent, appConfig)
platformBrowserDynamic().bootstrapModule(AppModule)
.catch((err) => console.error(err));